export default "__VITE_ASSET__yQe2u9kl__"